import { GET_USER_DOWNLOADS, GET_USER_DOWNLOADS_SUCCESS, GET_USER_DOWNLOADS_ERROR, GET_USER_DOWNLOADS_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetUserDownloads = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_DOWNLOADS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_USER_DOWNLOADS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_USER_DOWNLOADS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_USER_DOWNLOADS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetUserDownloads;
